window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import Vue from 'vue';
import i18n from './i18n';
import router from './router';
import store from './store';
window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status && error.config.url!='/api/login') {
        console.log(error.response)
        localStorage.removeItem('token')
        localStorage.removeItem('isLogin')
        store.state.login.isLogin=false;
        router.push('/login');
    } else if(403 == error.response.status && error.response.data.permission){
        Vue.toasted.error(i18n.t('access_denied_to')+i18n.t(error.response.data.permission));
        return Promise.reject(error);
    }
    else {
        return Promise.reject(error);
    }
});
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
